import React from 'react'
import {
  ProductOverview,
  StyledWidgetSkeletonWrapper,
  WidgetLoadingWrapper,
} from '../index-details/styled'
import CoverLoading from '../index-details/component/product-cover/loading'
import Skeleton from 'react-loading-skeleton'

export const StakingPageLoading: React.FC = () => {
  return (
    <>
      <ProductOverview>
        <CoverLoading />
        <WidgetLoadingWrapper>
          <StyledWidgetSkeletonWrapper>
            <Skeleton height={360} borderRadius="1.5rem" />
          </StyledWidgetSkeletonWrapper>
        </WidgetLoadingWrapper>
      </ProductOverview>
    </>
  )
}
export default StakingPageLoading
